module.exports = __webpack_public_path__ + "img/mp-lift.e388ffa9.jpg";